"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.deactivate2FAAuthentication = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _RestHelper = _interopRequireWildcard(require("../utils/RestHelper"));
var _CacheHandler = _interopRequireDefault(require("../../utils/CacheHandler"));
var _mainConfig = _interopRequireDefault(require("../../mainConfig"));
var _environmentHelper = require("../../utils/environmentHelper");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) { "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); } return f; })(e, t); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var addBusinessPartner = function addBusinessPartner(partnerData) {
  return _RestHelper.default.post("".concat(_RestHelper.default.getBaseUrl(), "/cscn-customer-srv/api/useraccount/v0/businesspartners"), partnerData, {}, true, true);
};
var registerUser = function registerUser(userDataObject, config) {
  return _RestHelper.default.post("".concat(_RestHelper.default.getBaseUrl(_RestHelper.MWDomains.cscAccount), "/public-api/v2/accounts"), {
    data: _objectSpread(_objectSpread({}, userDataObject.data), {}, {
      type: 'AccountResource'
    })
  }, config, true, false);
};
var deleteApp = function deleteApp(payload) {
  var promise = _RestHelper.default.post("".concat(_RestHelper.default.getBaseUrl(_RestHelper.MWDomains.cscAccount), "/api/v1/accounts/delete"), {
    data: {
      id: _CacheHandler.default.getCurrentCacheByToken('accountData').id,
      type: 'AccountDeactivationResource',
      attributes: _objectSpread({
        dso: _mainConfig.default.AEM_CONFIG.siteVariable
      }, payload)
    }
  });
  promise.then(function () {
    if (payload.applicationKeys) {
      var oldCache = _CacheHandler.default.getCurrentCacheByToken('accountData');
      var apps = oldCache.apps.filter(function (app) {
        return !payload.applicationKeys.find(function (deletedApp) {
          return deletedApp === app;
        });
      });
      var current = _objectSpread(_objectSpread({}, oldCache), {
        apps: apps
      });
      _CacheHandler.default.saveCache({
        accountData: current
      });
    }
  });
  return promise;
};
// v2 is not supported for pw reset. Hence v1 is used.
var resetPasswordInitiate = function resetPasswordInitiate(values) {
  var config = {
    headers: {
      captcha: values.captcha
    }
  };
  var resetPasswordInitiateRequest = {
    data: {
      type: 'ResetPasswordResource',
      attributes: {
        dso: _mainConfig.default.AEM_CONFIG.siteVariable,
        email: values.emailAddress,
        applicationKey: 'CSCN',
        aemInstanceKey: (0, _environmentHelper.getAemInstanceKey)()
      }
    }
  };
  return _RestHelper.default.post("".concat(_RestHelper.default.getBaseUrl(_RestHelper.MWDomains.cscAccount), "/public-api/v1/accounts/resetpassword"), resetPasswordInitiateRequest, config, true, false);
};
var deactivate2FAAuthentication = exports.deactivate2FAAuthentication = /*#__PURE__*/function () {
  var _ref = (0, _asyncToGenerator2.default)(/*#__PURE__*/_regenerator.default.mark(function _callee() {
    var _CacheHandler$getCurr;
    var egcid;
    return _regenerator.default.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            egcid = (_CacheHandler$getCurr = _CacheHandler.default.getCurrentCacheByToken('accountData')) === null || _CacheHandler$getCurr === void 0 ? void 0 : _CacheHandler$getCurr.id;
            return _context.abrupt("return", _RestHelper.default.delete("".concat(_RestHelper.default.getBaseUrl(_RestHelper.MWDomains.cscAccount), "/api/common/v1/accounts/deletemfa/").concat(egcid), {}, _RestHelper.default.setXClientHeader({}, _mainConfig.default.CHANNEL_CONFIG.portal)));
          case 2:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return function deactivate2FAAuthentication() {
    return _ref.apply(this, arguments);
  };
}();
var saveAccountData = function saveAccountData(accountData) {
  var requestData = {
    data: {
      id: _CacheHandler.default.getCurrentCacheByToken('accountData').id,
      type: 'AccountResource',
      attributes: _objectSpread(_objectSpread({}, accountData), {}, {
        aemInstanceKey: (0, _environmentHelper.getAemInstanceKey)(),
        dso: _mainConfig.default.AEM_CONFIG.siteVariable,
        applicationKey: 'CSCN'
      })
    }
  };
  return _RestHelper.default.patch("".concat(_RestHelper.default.getBaseUrl(_RestHelper.MWDomains.cscAccount), "/api/v1/accounts"), requestData, _RestHelper.default.setXClientHeader({}, _mainConfig.default.CHANNEL_CONFIG.portal));
};
var _default = exports.default = {
  deactivate2FAAuthentication: deactivate2FAAuthentication,
  addBusinessPartner: addBusinessPartner,
  registerUser: registerUser,
  deleteApp: deleteApp,
  resetPasswordInitiate: resetPasswordInitiate,
  saveAccountData: saveAccountData
};